import { render } from "./DistinguishingCancelAndClose.vue?vue&type=template&id=380cc95a"
import script from "./DistinguishingCancelAndClose.vue?vue&type=script&lang=js"
export * from "./DistinguishingCancelAndClose.vue?vue&type=script&lang=js"
script.render = render

export default script